

















































































import Vue from 'vue'

import MetricTextLabel from '@/components/shift-and-round-reports/components/MetricTextLabel.vue'
import MetricChangeLabel from '@/components/shift-and-round-reports/components/MetricChangeLabel.vue'
import VitalSignStats from '@/components/shift-and-round-reports/components/VitalSignStats.vue'

const enum UnitRoundColumnNames {
  RoomNumber = 'RM #',
  Falls = 'Falls',
  PressureInjury = 'Pressure Injury / Risk of Injury',
  Uti = 'UTI / Risk of UTI',
  SleepTime = 'Sleep Time',
  Awakenings = 'Awakenings',
  Activity = 'Activity',
  VitalSigns = 'Vital Signs',
  Weight = 'Weight',
  Elop = 'Elop.',
  AttemptedElop = 'ATPT. ELOP. / Location',
  RiskStatisticChange = 'Risk Stat. Chg',
}

const enum UnitRoundTableItemKeys {
  RoomNumber = 'roomNumber',
  Falls = 'falls',
  PressureInjury = 'pressureInjury',
  Uti = 'uti',
  SleepTime = 'sleepTime',
  Awakenings = 'awakenings',
  Activity = 'activity',
  VitalSigns = 'vitalSigns',
  Weight = 'weight',
  Elop = 'elop',
  AttemptedElop = 'attemptedElop',
  RiskStatisticChange = 'riskStatisticChange',
}

export default Vue.extend({
  components: {
    MetricTextLabel,
    MetricChangeLabel,
    VitalSignStats,
  },
  props: {
    unitRoundReport: {
      type: Array,
      default: () => [],
    },
    showLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      unitRoundColumnNames: [
        UnitRoundColumnNames.RoomNumber,
        UnitRoundColumnNames.Falls,
        UnitRoundColumnNames.PressureInjury,
        UnitRoundColumnNames.Uti,
        UnitRoundColumnNames.SleepTime,
        UnitRoundColumnNames.Awakenings,
        UnitRoundColumnNames.Activity,
        UnitRoundColumnNames.VitalSigns,
        UnitRoundColumnNames.Weight,
        UnitRoundColumnNames.Elop,
        UnitRoundColumnNames.AttemptedElop,
        UnitRoundColumnNames.RiskStatisticChange,
      ],
      unitRoundTableItemKeys: [
        UnitRoundTableItemKeys.RoomNumber,
        UnitRoundTableItemKeys.Falls,
        UnitRoundTableItemKeys.PressureInjury,
        UnitRoundTableItemKeys.Uti,
        UnitRoundTableItemKeys.SleepTime,
        UnitRoundTableItemKeys.Awakenings,
        UnitRoundTableItemKeys.Activity,
        UnitRoundTableItemKeys.VitalSigns,
        UnitRoundTableItemKeys.Weight,
        UnitRoundTableItemKeys.Elop,
        UnitRoundTableItemKeys.AttemptedElop,
        UnitRoundTableItemKeys.RiskStatisticChange,
      ],
      loadingText: 'Generating report. This may take a few seconds...',
      sortBy: UnitRoundTableItemKeys.RoomNumber,
    }
  },
  computed: {
    tableHeaders() {
      return this.unitRoundColumnNames.map((columnName, index) => ({
        text: columnName,
        value: this.unitRoundTableItemKeys[index],
        sortable: [
          UnitRoundColumnNames.RoomNumber,
          UnitRoundColumnNames.SleepTime,
          UnitRoundColumnNames.Awakenings,
          UnitRoundColumnNames.Activity,
        ].includes(columnName)
          ? true
          : false,
        sort: (a, b) => {
          return columnName === UnitRoundColumnNames.RoomNumber
            ? this.sortByRoomNumber(a, b)
            : this.sortByNumericValue(a, b)
        },
        class: ['text-uppercase', 'steel-blue--text', 'light-grey'],
        divider: true,
      }))
    },
    orderedUnitRoundReport() {
      return this.unitRoundReport
        .map(room => {
          const roomNumber = room.unitRoundStats.find(stat => stat.title === UnitRoundColumnNames.RoomNumber)
          return {
            ...room,
            roomNumber: roomNumber.value ? parseInt(roomNumber.value) : false,
          }
        })
        .filter(room => room.roomNumber)
        .sort((a, b) => (a.roomNumber > b.roomNumber ? 1 : -1))
    },
    dataForTable() {
      if (this.showLoading) return []
      const tableRows = []
      this.orderedUnitRoundReport.forEach(report => {
        const rowObject = {}
        this.unitRoundColumnNames.forEach((columnName, index) => {
          const columnData = report.unitRoundStats.find(stat => stat.title === columnName)
          rowObject[this.unitRoundTableItemKeys[index]] = columnData || { title: '', value: null }
        })
        tableRows.push(rowObject)
      })
      return tableRows
    },
  },
  methods: {
    getRiskLabelText(risk) {
      const riskMap = {
        'high-risk': 'High Risk',
        'low-risk': 'Low Risk',
      }
      return riskMap[risk]
    },
    sortByNumericValue(a, b) {
      if (a.numericValue === null || a.change === null) {
        return 1
      } else if (b.numericValue === null || b.change === null) {
        return -1
      }
      return a.numericValue > b.numericValue ? 1 : -1
    },
    sortByRoomNumber(a, b) {
      return parseInt(a.value) > parseInt(b.value) ? 1 : -1
    },
  },
})
